import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef } from "react";
import { useFormContext } from "react-hook-form";
import type { RegisterOptions } from "react-hook-form";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface Option {
  label: string;
  value: string | number;
}

export interface FormSelectNativeProps extends ComponentPropsWithoutRef<"select"> {
  className?: string;
  isPromptDisabled?: boolean;
  name: string;
  options: Array<Option> | ReadonlyArray<Option>;
  prompt?: string;
  rules?: RegisterOptions;
}

export const FormSelectNative = ({
  name,
  rules = {},
  options,
  className: classNameProp,
  prompt = "",
  isPromptDisabled = true,
  ...rest
}: FormSelectNativeProps) => {
  const className = classNameProp ?? anchorClassNames("form-control");
  const { register } = useFormContext();

  return (
    <select
      {...rest}
      {...register(name, rules)}
      className={classNames(
        "disabled:bg-secondary focus:!outline-secondary focus:!outline-1 focus:!outline-offset-0 disabled:cursor-not-allowed",
        className,
      )}
      name={name}
    >
      {prompt && (
        <option value="" disabled={isPromptDisabled}>
          {prompt}
        </option>
      )}
      {options.map(({ label, value }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
};

FormSelectNative.displayName = "Form.SelectNative";
